import { TypedStartListening, createListenerMiddleware } from "@reduxjs/toolkit";
import type { AppDispatch, RootState } from "./store.types";

/**
 * Setup listener middleware
 */
export const listenerMiddleware = createListenerMiddleware();

export const startAppListening = listenerMiddleware.startListening as TypedStartListening<RootState, AppDispatch>;
